import angular from 'angular';

export default class ModalQueryJsonController {
	/* @ngInject */
	/**
	 * @param {any} $copyToClipboard
	 * @param {import('angular').IFilterService} $filter
	 * @param {any} $scope
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('~/scripts/services/model/query').default} query
	 */
	constructor(
		$copyToClipboard,
		$filter,
		$scope,
		$translate,
		$uibModalInstance,
		query,
	) {
		this.$copyToClipboard = $copyToClipboard;
		this.$filter = $filter;
		this.$translate = $translate;
		this.$uibModalInstance = $uibModalInstance;
		this.query = query;
		this.jsonEditorOptions = {
			mode: 'code',
			onEditable: () => false,
		};
		this.resizing = false;

		$scope.$on('modal.closing', (/** @type {Event} */ event) => {
			if (this.resizing) {
				event.preventDefault();
			}
		});
	}

	copyAll() {
		this.$copyToClipboard(
			angular.toJson(this.query),
			true,
			(/** @type {string} */ v) => this.$filter('sprintf')(
				this.$translate.instant('common.x-copied-to-clipboard'),
				`<samp>${v.slice(0, 30)}...</samp>`,
			),
		);
	}

	close() {
		this.$uibModalInstance.close(false);
	}

	export() {
		this.$uibModalInstance.close(true);
	}
}
